import React, { useContext } from 'react'
import { useState, useEffect } from 'react';

//***********************Componentes PrimeReact****************************************** */
import { Tag } from 'primereact/tag';

//***********************Componentes Generales*************************************** */
import AgGrid from "../../../Components/Tables/AgGrid/AgGrid"
import Loader from '../../../Components/Loader/Loader'

//***************************Consultas API************************************************* */
import { getProveedoresCAI } from '../../../API/Proveedores/ProveedoresRequest'


//*********************************Componentes Especificos********************************************** */
import ModalProveedoresCAI from './ModalProveedorCAI';
import { AuthContext } from '../../../Context/AuthContext/AuthContext';
import { Button } from 'primereact/button';
import Card from '../../../Components/Card/Card';

const ProveedoresCAIScreen = () => {

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([])

    const [IdProveedor, setIdProveedor] = useState(0)
    const [dialogCAI, setDialogCAI] = useState(false);
    const { userAuth } = useContext(AuthContext)


    const obtenerInformacion = async () => {
        setLoading(true)
        const result = await getProveedoresCAI()

        setData(result)
        setLoading(false)
    }

    const openDialog = (Id) => {
        setIdProveedor(Id)
        setDialogCAI(true)
    }

    const hideDialog = () => {
        setDialogCAI(false)
        setIdProveedor(0)
    }


    const EstadoTemplate = (StatusName) => {
        switch (StatusName) {
            case "Active":
                return <Tag style={{ width: 60, backgroundColor: "rgb(0, 191, 57)" }} value={StatusName} />
                break;
            case "Inactive":
                return <Tag style={{ width: 60, backgroundColor: "rgb(227, 63, 63)" }} value={StatusName} />
                break;
            case "Delete":
                return <Tag style={{ width: 60, backgroundColor: "rgb(197 197 197)" }} value={StatusName} />
                break;
            default:
                return <div style={{ textAlign: 'center' }}><span>{StatusName}</span></div>
                break;
        }
    }

    const table = {
        Data: data,
        Columns: [
            {
                field: 'IdProveedorCAI',
                header: 'IdCAI',
                headerEn: 'IdCAI',
                className: 'Xsmall',
                width: 60,
                hidden: userAuth.IdRol === 1,
                frozen: true,
                alignFrozen: 'left'
            },

            {
                field: 'CodigoCompany',
                header: 'Codigo',
                headerEn: 'Code',
                className: 'Xsmall',
                frozen: true,
                alignFrozen: 'left'
            },
            {
                field: 'CustomerName',
                header: 'Proveedor',
                headerEn: 'Supplier',
                className: 'Xlarge',
                filter: true,
                flex: 1
            },
            {
                field: 'NombreSucursal',
                header: 'Nombre Sucursal',
                headerEn:'Branch name',
                className: 'Xlarge',
                Sumary: 'count',
                filter: true,
            },
            {
                field: 'StatusName',
                header: 'Estado',
                headerEn: 'Status',
                className: 'Xsmall',
                filter: true,
                Format: "Template",
                body: (rowData) => EstadoTemplate(rowData.StatusName),

            },
            {
                field: 'Prefijo',
                header: 'Prefijo',
                headerEn: 'Prefix',
                className: 'medium',
                filter: true
            },
            {
                field: 'NoCAI',
                header: 'NoCAI',
                headerEn: 'No CAI',
                className: 'XXXlarge',
                filter: true
            },
            {
                field: 'RangoInicial',
                header: 'Rango Inicial',
                headerEn: 'Initial Range',
                className: 'Xsmall',
                filter: true
            },
            {
                field: 'RangoFinal',
                header: 'Rango Final',
                headerEn: 'End Range',
                className: 'Xsmall',
                filter: true
            },
            {
                field: 'TipoCAI',
                header: 'Tipo CAI',
                headerEn: 'Tipo CAI',
                className: 'large',
                filter: true
            },
            {
                field: 'FechaVencimiento',
                header: 'Fecha Vencimiento',
                headerEn: 'Date',
                className: 'Xsmall',
                filter: true,
                Template: "DateTime"
            },
            {
                field: 'IdProveedor',
                header: '',
                Format: 'Botones',
                frozen: true,
                alignFrozen: 'right',
                Botones: [
                    {
                        icon: 'pi pi-pencil',
                        tooltip: 'Editar',
                        onClick: (rowData) => {
                            openDialog(rowData.IdProveedor)
                        }
                    },

                ]
            }

        ]
    }

    useEffect(() => {
        obtenerInformacion()
    }, [])



    return (
        <div style={{ width: '99%', height: '90vh' }}>
            <Loader loading={loading} querySelector='#CAIS' />
            <Card
                titulo={<div>
                    <Button icon='pi pi-refresh' onClick={() => obtenerInformacion()} loading={loading} />
                </div>}
                contenido={
                    <div className='pt-4' style={{ height: '85vh' }} id='CAIS'>
                        <AgGrid table={table} />
                    </div>
                }
            />

            <ModalProveedoresCAI
                proveedoresCAIDialog={dialogCAI}
                setProveedoresCAIDialog={setDialogCAI}
                hideDialog={hideDialog}
                IdProveedor={IdProveedor}
            />
        </div>
    )
}

export default ProveedoresCAIScreen